import React from 'react';
import { AllieCheckbox } from '../../../Checkbox';
import { DataGridHeaderBaseProps } from '../../DataGridHeader.types';

export type DataGridCheckHeaderProps = {};

export const DataGridCheckHeader: React.FC<DataGridHeaderBaseProps> = ({
  headerProps: { table },
}) => {
  return (
    <AllieCheckbox
      {...{
        checked: table.getIsAllRowsSelected(),
        indeterminate: table.getIsSomeRowsSelected(),
        onClick: table.getToggleAllRowsSelectedHandler(),
        size: 24,
      }}
    />
  );
};
